import * as ActionsTypes from "../../../common/state/StateConstants";

export const searchTitres = (searchObject, expanded) => {
  return {
    type: ActionsTypes.SEARCH_TITRE,
    searchObject,
    expanded,
  };
};

export const searchTitresSuccess = (data) => {
  return {
    type: ActionsTypes.SEARCH_TITRE_SUCCESS,
    data,
  };
};

export const searchTitresFailure = (error) => {
  return {
    type: ActionsTypes.SEARCH_TITRE_FAILURE,
    error,
  };
};

export const clearTiSearchForm = () => {
  return {
    type: ActionsTypes.CLEAR_TI_SEARCH_FORM,
  };
};

export const setIsTiDecisionMode = (data) => {
  return {
    type: ActionsTypes.SET_TI_DECISION_MODE,
    data,
  };
};

export const getTiImportateurs = (payload) => {
  return {
    type: ActionsTypes.FETCH_TI_IMPORTATEURS,
    payload,
  };
};

export const getTiImportateursSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_IMPORTATEURS_SUCCESS,
    data,
  };
};

export const getTiImportateursFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_IMPORTATEURS_FAILURE,
    error,
  };
};

export const getTiNomenclatures = (payload) => {
  return {
    type: ActionsTypes.FETCH_TI_NOMENCLATURES,
    payload,
  };
};

export const getTiNomenclaturesSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_NOMENCLATURES_SUCCESS,
    data,
  };
};

export const getTiNomenclaturesFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_NOMENCLATURES_FAILURE,
    error,
  };
};

export const getTiGuichets = (payload) => {
  return {
    type: ActionsTypes.FETCH_TI_GUICHETS,
    payload,
  };
};

export const getTiGuichetsSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_GUICHETS_SUCCESS,
    data,
  };
};

export const getTiGuichetsFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_GUICHETS_FAILURE,
    error,
  };
};

export const getTiDeclarants = (payload) => {
  return {
    type: ActionsTypes.FETCH_TI_DECLARANTS,
    payload,
  };
};

export const getTiDeclarantsSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_DECLARANTS_SUCCESS,
    data,
  };
};

export const getTiDeclarantsFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_DECLARANTS_FAILURE,
    error,
  };
};

export const getTiEtats = () => {
  return {
    type: ActionsTypes.FETCH_TI_ETATS,
  };
};

export const getTiEtatsSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_ETATS_SUCCESS,
    data,
  };
};

export const getTiEtatsFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_ETATS_FAILURE,
    error,
  };
};

export const getTiLocalites = () => {
  return {
    type: ActionsTypes.FETCH_TI_LOCALITES,
  };
};

export const getTiLocalitesSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_LOCALITES_SUCCESS,
    data,
  };
};

export const getTiLocalitesFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_LOCALITES_FAILURE,
    error,
  };
};

export const getTiCategories = () => {
  return {
    type: ActionsTypes.FETCH_TI_CATEGORIES,
  };
};

export const getTiCategoriesSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_CATEGORIES_SUCCESS,
    data,
  };
};

export const getTiCategoriesFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_CATEGORIES_FAILURE,
    error,
  };
};

export const getTiStatusModif = () => {
  return {
    type: ActionsTypes.FETCH_TI_STATUS_MODIF,
  };
};

export const getTiStatusModifSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_STATUS_MODIF_SUCCESS,
    data,
  };
};

export const getTiStatusModifFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_STATUS_MODIF_FAILURE,
    error,
  };
};

export const getTiTypeMessage = () => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_MESSAGE,
  };
};

export const getTiTypeMessageSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_MESSAGE_SUCCESS,
    data,
  };
};

export const getTiTypeMessageFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_MESSAGE_FAILURE,
    error,
  };
};

export const getTiBanque = () => {
  return {
    type: ActionsTypes.FETCH_TI_BANQUE,
  };
};

export const getTiBanqueSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_BANQUE_SUCCESS,
    data,
  };
};

export const getTiBanqueFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_BANQUE_FAILURE,
    error,
  };
};

export const getTypeReglement = () => {
  return {
    type: ActionsTypes.FETCH_TYPE_REGLEMENT,
  };
};

export const getTypeReglementSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TYPE_REGLEMENT_SUCCESS,
    data,
  };
};

export const getTypeReglementFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TYPE_REGLEMENT_FAILURE,
    error,
  };
};

export const getModeReglement = () => {
  return {
    type: ActionsTypes.FETCH_MODE_REGLEMENT,
  };
};

export const getModeReglementSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_MODE_REGLEMENT_SUCCESS,
    data,
  };
};

export const getModeReglementFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_MODE_REGLEMENT_FAILURE,
    error,
  };
};

export const getTiApurement = () => {
  return {
    type: ActionsTypes.FETCH_TI_APUREMENT,
  };
};

export const getTiApurementSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_APUREMENT_SUCCESS,
    data,
  };
};

export const getTiApurementFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_APUREMENT_FAILURE,
    error,
  };
};

export const getTiTypeTE = () => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_TE,
  };
};

export const getTiTypeTESuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_TE_SUCCESS,
    data,
  };
};

export const getTiTypeTEFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_TE_FAILURE,
    error,
  };
};

export const getTiTypeTI = () => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_TI,
  };
};

export const getTiTypeTISuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_TI_SUCCESS,
    data,
  };
};

export const getTiTypeTIFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_TI_FAILURE,
    error,
  };
};

export const searchAllTitres = (searchObject) => {
  return {
    type: ActionsTypes.SEARCH_ALL_TITRES,
    searchObject,
  };
};

export const searchAllTitresSuccess = (data) => {
  return {
    type: ActionsTypes.SEARCH_ALL_TITRES_SUCCESS,
    data,
  };
};

export const searchAllTitresFailure = (error) => {
  return {
    type: ActionsTypes.SEARCH_ALL_TITRES_FAILURE,
    error,
  };
};

export const getTi = (id, mode) => {
  return {
    type: ActionsTypes.FETCH_TI,
    id,
    mode,
  };
};

export const getTiSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_SUCCESS,
    data,
  };
};

export const getTiFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_FAILURE,
    error,
  };
};

export const setIsDecisionTiVisible = (data) => {
  return {
    type: ActionsTypes.SET_DECISION_TI_VISIBLE,
    data,
  };
};

export const downloadTi = (id) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI,
    id,
  };
};

export const downloadTiSuccess = (data) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI_SUCCESS,
    data,
  };
};

export const downloadTiFailure = (error) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI_FAILURE,
    error,
  };
};

export const downloadTiFactureDocument = (guId, parentId, action) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI_FACTURE_DOCUMENT,
    guId,
    parentId,
    action,
  };
};

export const downloadTiFactureDocumentSuccess = (data) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI_FACTURE_DOCUMENT_SUCCESS,
    data,
  };
};

export const downloadTiFactureDocumentFailure = (error) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI_FACTURE_DOCUMENT_FAILURE,
    error,
  };
};

export const downloadTiDocument = (guId, parentId, action) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI_DOCUMENT,
    guId,
    parentId,
    action,
  };
};

export const downloadTiDocumentSuccess = (data) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI_DOCUMENT_SUCCESS,
    data,
  };
};

export const downloadTiDocumentFailure = (error) => {
  return {
    type: ActionsTypes.DOWNLOAD_TI_DOCUMENT_FAILURE,
    error,
  };
};

export const clearTiDetails = () => {
  return {
    type: ActionsTypes.CLEAR_TITRE_DETIALS,
  };
};

export const clearTiErrors = () => {
  return {
    type: ActionsTypes.CLEAR_TITRE_ERROR,
  };
};

export const clearTiHistorique = () => {
  return {
    type: ActionsTypes.CLEAR_HISTORIQUE_TI,
  };
};

export const fetchTiHistorique = (id) => {
  return {
    type: ActionsTypes.FETCH_HISTORIQUE_TI,
    id,
  };
};

export const fetchTiHistoriqueSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_HISTORIQUE_TI_SUCCESS,
    data,
  };
};

export const fetchTiHistoriqueFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_HISTORIQUE_TI_FAILURE,
    error,
  };
};

export const getTiDepartments = () => {
  return {
    type: ActionsTypes.FETCH_DEPARTMENTS_TI,
  };
};

export const getTiDepartmentsSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_DEPARTMENTS_TI_SUCCESS,
    data,
  };
};

export const getTiDepartmentsFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_DEPARTMENTS_TI_FAILURE,
    error,
  };
};

export const transferTi = (payload) => {
  return {
    type: ActionsTypes.TRANSFER_TI,
    payload,
  };
};

export const transferTiSuccess = (data) => {
  return {
    type: ActionsTypes.TRANSFER_TI_SUCCESS,
    data,
  };
};

export const transferTiFailure = (error) => {
  return {
    type: ActionsTypes.TRANSFER_TI_FAILURE,
    error,
  };
};

export const transferTiProlong = (payload) => {
  return {
    type: ActionsTypes.TRANSFER_TI_PROLONG,
    payload,
  };
};

export const transferTiProlongSuccess = (data) => {
  return {
    type: ActionsTypes.TRANSFER_TI_PROLONG_SUCCESS,
    data,
  };
};

export const transferTiProlongFailure = (error) => {
  return {
    type: ActionsTypes.TRANSFER_TI_PROLONG_FAILURE,
    error,
  };
};

export const getTiDecisionTypeMCE = () => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_DECISION_MCE,
  };
};

export const getTiDecisionTypeMCESuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_SUCCESS,
    data,
  };
};

export const getTiDecisionTypeMCEFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_FAILURE,
    error,
  };
};

export const postTiDecisionMCE = (payload) => {
  return {
    type: ActionsTypes.POST_TI_DECISION_MCE,
    payload,
  };
};

export const postTiDecisionMCESuccess = (data) => {
  return {
    type: ActionsTypes.POST_TI_DECISION_MCE_SUCCESS,
    data,
  };
};

export const postTiDecisionMCEFailure = (error) => {
  return {
    type: ActionsTypes.POST_TI_DECISION_MCE_FAILURE,
    error,
  };
};

export const postTiDecisionDEP = (payload) => {
  return {
    type: ActionsTypes.POST_TI_DECISION_DEP,
    payload,
  };
};

export const postTiDecisionDEPSuccess = (data) => {
  return {
    type: ActionsTypes.POST_TI_DECISION_DEP_SUCCESS,
    data,
  };
};

export const postTiDecisionDEPFailure = (error) => {
  return {
    type: ActionsTypes.POST_TI_DECISION_DEP_FAILURE,
    error,
  };
};

export const getTiDecisionTypeMCEProlong = () => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_PROLONG,
  };
};

export const getTiDecisionTypeMCEProlongSuccess = (data) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_PROLONG_SUCCESS,
    data,
  };
};

export const getTiDecisionTypeMCEProlongFailure = (error) => {
  return {
    type: ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_PROLONG_FAILURE,
    error,
  };
};

export const postTiProlongMCE = (payload) => {
  return {
    type: ActionsTypes.POST_TI_PROLONG_MCE,
    payload,
  };
};

export const postTiProlongMCESuccess = (data) => {
  return {
    type: ActionsTypes.POST_TI_PROLONG_MCE_SUCCESS,
    data,
  };
};

export const postTiProlongMCEFailure = (error) => {
  return {
    type: ActionsTypes.POST_TI_PROLONG_MCE_FAILURE,
    error,
  };
};

export const postTiProlongDEP = (payload) => {
  return {
    type: ActionsTypes.POST_TI_PROLONG_DEP,
    payload,
  };
};

export const postTiProlongDEPSuccess = (data) => {
  return {
    type: ActionsTypes.POST_TI_PROLONG_DEP_SUCCESS,
    data,
  };
};

export const postTiProlongDEPFailure = (error) => {
  return {
    type: ActionsTypes.POST_TI_PROLONG_DEP_FAILURE,
    error,
  };
};

export const setDrawerState = (data) => {
  return {
    type: ActionsTypes.SET_DRAWER_STATE,
    data,
  };
};

export const setTiColumnsDensityState = (data) => {
  return {
    type: ActionsTypes.SET_TI_COLUMNS_DENSITY_STATE,
    data,
  };
};

export const getTiColumnsDensityState = () => {
  return {
    type: ActionsTypes.GET_TI_COLUMNS_DENSITY_STATE,
  };
};

export const getTiColumnsDensityStateSuccess = (data) => {
  return {
    type: ActionsTypes.GET_TI_COLUMNS_DENSITY_STATE_SUCCESS,
    data,
  };
};

export const getTiColumnsDensityStateFailure = (error) => {
  return {
    type: ActionsTypes.GET_TI_COLUMNS_DENSITY_STATE_SUCCESS,
    error,
  };
};

export const fetchKpiTi = (year) => {
  return {
    type: ActionsTypes.TI_KPI,
    year,
  };
};

export const fetchKpiTiSuccess = (data) => {
  return {
    type: ActionsTypes.TI_KPI_SUCCESS,
    data,
  };
};

export const fetchKpiTiFailure = (error) => {
  return {
    type: ActionsTypes.TI_KPI_FAILURE,
    error,
  };
};

export const authenticate = (payload) => {
  return {
    type: ActionsTypes.AUTHENTICATE_USER,
    payload,
  };
};

export const authenticateSuccess = (data) => {
  return {
    type: ActionsTypes.AUTHENTICATE_USER_SUCCESS,
    data,
  };
};

export const authenticateFailure = (error) => {
  return {
    type: ActionsTypes.AUTHENTICATE_USER_FAILURE,
    error,
  };
};

export const registerMFA = (payload) => {
  return {
    type: ActionsTypes.REGISTER_MFA,
    payload,
  };
};

export const registerMFASuccess = (data) => {
  return {
    type: ActionsTypes.REGISTER_MFA_SUCCESS,
    data,
  };
};

export const registerMFAFailure = (error) => {
  return {
    type: ActionsTypes.REGISTER_MFA_FAILURE,
    error,
  };
};

export const sendOtpMail = (payload) => ({
  type: ActionsTypes.SEND_OTP_MAIL,
  payload,
});

export const sendOtpMailSuccess = (data) => ({
  type: ActionsTypes.SEND_OTP_MAIL_SUCCESS,
  data,
});

export const sendOtpMailFailure = (error) => ({
  type: ActionsTypes.SEND_OTP_MAIL_FAILURE,
  error,
});

export const postChangePassword = (payload) => {
  return {
    type: ActionsTypes.POST_CHANGE_PASSWORD,
    payload,
  };
};

export const postChangePasswordSuccess = (data) => {
  return {
    type: ActionsTypes.POST_CHANGE_PASSWORD_SUCCESS,
    data,
  };
};

export const postChangePasswordFailure = (error) => {
  return {
    type: ActionsTypes.POST_CHANGE_PASSWORD_FAILURE,
    error,
  };
};

export const clearChangePasswordState = () => {
  return {
    type: ActionsTypes.CLEAR_CHANGE_PASSWORD,
  };
};

export const setIsAuthenticated = (data) => {
  return {
    type: ActionsTypes.SET_IS_AUTHENTICATED,
    data,
  };
};

export const resetError = () => {
  return {
    type: ActionsTypes.RESET_ERROR,
  };
};

export const resetState = () => {
  return {
    type: ActionsTypes.RESET_STATE,
  };
};

/*--------------------------------------------------GET-REPONSE-DOMICILIATION-BANQUE----------------------------------------------------*/
export const getReponseDomiciliationBanqueData = (payload) => {
  return {
    type: ActionsTypes.GET_REPONSE_DOMICILIATION_BANQUE_DATA,
    payload,
  };
};

export const getReponseDomiciliationBanqueDataSuccess = (payload) => {
  return {
    type: ActionsTypes.GET_REPONSE_DOMICILIATION_BANQUE_DATA_SUCCESS,
    payload,
  };
};

export const getReponseDomiciliationBanqueDataFail = (payload) => {
  return {
    type: ActionsTypes.GET_REPONSE_DOMICILIATION_BANQUE_DATA_FAIL,
    payload,
  };
};
/*--------------------------------------------------ACCEPT-DOMICILIATION-BANQUE----------------------------------------------------*/
export const acceptDomiciliationBanque = (payload, callback) => {
  return {
    type: ActionsTypes.ACCEPT_DOMICILIATION_BANQUE,
    payload,
    callback,
  };
};

export const acceptDomiciliationBanqueSuccess = (payload) => {
  return {
    type: ActionsTypes.ACCEPT_DOMICILIATION_BANQUE_SUCCESS,
    payload,
  };
};

export const acceptDomiciliationBanqueFail = (payload) => {
  return {
    type: ActionsTypes.ACCEPT_DOMICILIATION_BANQUE_FAIL,
    payload,
  };
};
export const acceptDomiciliationBanqueReinitialization = (payload) => {
  return {
    type: ActionsTypes.ACCEPT_DOMICILIATION_BANQUE_REINITIALIZATION,
    payload,
  };
};

/*--------------------------------------------------REFUSE-DOMICILIATION-BANQUE----------------------------------------------------*/
export const refuseDomiciliationBanque = (payload, callback) => {
  return {
    type: ActionsTypes.REFUSE_DOMICILIATION_BANQUE,
    payload,
    callback,
  };
};

export const refuseDomiciliationBanqueSuccess = (payload) => {
  return {
    type: ActionsTypes.REFUSE_DOMICILIATION_BANQUE_SUCCESS,
    payload,
  };
};

export const refuseDomiciliationBanqueFail = (payload) => {
  return {
    type: ActionsTypes.REFUSE_DOMICILIATION_BANQUE_FAIL,
    payload,
  };
};

export const refuseDomiciliationBanqueReinitialization = (payload) => {
  return {
    type: ActionsTypes.REFUSE_DOMICILIATION_BANQUE_REINITIALIZATION,
    payload,
  };
};

export const postDonnesReglements = (payload) => {
  return {
    type: ActionsTypes.POST_DONNEES_REGLEMENT,
    payload,
  };
};

export const postDonnesReglementsSuccess = (data) => {
  return {
    type: ActionsTypes.POST_DONNEES_REGLEMENT_SUCCESS,
    data,
  };
};

export const postDonnesReglementsFailure = (error) => {
  return {
    type: ActionsTypes.POST_DONNEES_REGLEMENT_FAILURE,
    error,
  };
};

export const setConsultingMode = (data) => {
  return {
    type: ActionsTypes.SET_CONSULTING_MODE,
    data,
  };
};
